import { createSlice } from '@reduxjs/toolkit';
// import moment from "moment";
import { MessageType } from '../../app/common/constants/values';
import {
  fetchSitesByCampaignId,
  deleteSite,
  insertSite,
  updateSite,
  fetchShortcutsByCampaignId,
  insertShortCut,
  updateShortcut,
  deleteShortcut,
  getAllCampaigns,
  createCampaign,
  updateCampaign,
  deleteCampaign,
  getUserCampaignsByEmail,
  fetchDispositionsByCampaignId,
  updateDisposition,
  createDisposition,
  deleteDisposition,
} from './settingsAPI';
import { saveItem } from '../../app/common/libs/localstorage';
import { toast } from 'react-toastify';

export const initialState = {
  loading: false,
  error: null,
  editModalOpen: false,
  deleteModalOpen: false,
  showSiteSuccessToast: false,
  isSiteOnline: false,
  showBotSuccessToast: false,
  isBotEnabled: false,
  totalCount: 0,
  // pageNo:0,
  // pageSize:10,
  // filterState: {
  //     filterBy: '',
  //     filterValue: '',
  //     channelType: null,
  //     rated: null,
  //     status: null
  // },
  data: [],
  filteredData: [],
  campaignsData: [],
  filteredCampaignData: [],
  dispositionData: [],
  filteredDispositionData: [],
  sucess: false,
  campaignFormData: {},
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState: initialState,
  reducers: {
    setCampaignFormData: (state, action) => {
      state.campaignFormData =
        Object.keys(action.payload).length !== 0
          ? { ...state.campaignFormData, ...action.payload }
          : {};
    },
    setErrorAndSucess: (state, action) => {
      console.log('action payload => ', action.payload);
      state.error = action.payload.error;
      state.sucess = action.payload.sucess;
    },
    setModalState: (state, action) => {
      state.editModalOpen = action.payload;
    },
    setDeleteModalState: (state, action) => {
      state.deleteModalOpen = action.payload;
    },
    changeBotAvailability: (state, action) => {
      var site = state.data.find((x) => x.id === action.payload);
      site.isBotEnabled = !site.isBotEnabled;
      state.showBotSuccessToast = true;
      state.isBotEnabled = site.isBotEnabled;
    },
    changeSiteAvailability: (state, action) => {
      var site = state.data.find((x) => x.id === action.payload);
      site.isSiteOnline = !site.isSiteOnline;
      state.showSiteSuccessToast = true;
      state.isSiteOnline = site.isSiteOnline;
    },
    filterShortcutsData: (state, action) => {
      state.filteredData = state.data.filter(
        (d) =>
          d.key.toLowerCase().includes(action.payload.toLowerCase()) ||
          d.value.toLowerCase().includes(action.payload.toLowerCase())
      );
      if (action.payload === '') state.filteredData = state.data;
      state.totalCount = state.filteredData.length;
    },
    filterDispositionData: (state, action) => {
      state.filteredDispositionData = state.dispositionData.filter((d) =>
        d.toLowerCase().includes(action.payload.toLowerCase())
      );
      if (action.payload === '')
        state.filteredDispositionData = state.dispositionData;
      state.totalCount = state.filteredDispositionData.length;
    },
    filterCampaignData: (state, action) => {
      state.filteredCampaignData = state.campaignsData.filter((d) =>
        d.name.toLowerCase().includes(action.payload.toLowerCase())
      );
      if (action.payload === '')
        state.filteredCampaignData = state.campaignsData;
    },
    filterSitesData: (state, action) => {
      state.filteredData = state.data.filter(
        (d) =>
          d.name.toLowerCase().includes(action.payload.toLowerCase()) ||
          d.url.toLowerCase().includes(action.payload.toLowerCase()) ||
          d.botWelcomeMessage
            .toLowerCase()
            .includes(action.payload.toLowerCase())
      );
      if (action.payload === '') state.filteredData = state.data;
      state.totalCount = state.filteredData.length;
    },
  },
  extraReducers: {
    [fetchSitesByCampaignId.pending]: (state) => {
      state.loading = true;
    },
    [fetchSitesByCampaignId.rejected]: (state, { meta, error }) => {
      state.loading = false;
      state.data = state.filteredData = [];
      state.error = error;

      toast.error(`${meta.arg} ' : Unable to get sites...!`);
    },
    [fetchSitesByCampaignId.fulfilled]: (
      state,
      { meta, payload: { data } }
    ) => {
      state.loading = false;
      state.error = '';
      state.totalCount = data.length;
      state.data = state.filteredData = data;

      // console.log('state.data = data.transcripts')
      console.log('Sites' + data);
    },
    [deleteSite.pending]: (state) => {
      state.loading = true;
    },
    [deleteSite.rejected]: (state, { meta, error }) => {
      state.loading = false;
      state.deleteModalOpen = false;
      toast.error(`${meta.arg} ' : Unable to delete site`);
    },
    [deleteSite.fulfilled]: (state, { meta, payload: { data } }) => {
      state.loading = false;
      state.deleteModalOpen = false;
      state.data = state.filteredData = state.data.filter(
        (x) => x.id !== meta.arg
      );
      state.totalCount = state.data.length;
      toast.success(`Site deleted successfully`);
    },
    [insertSite.pending]: (state) => {
      state.loading = true;
    },
    [insertSite.rejected]: (state, { meta, error }) => {
      state.loading = false;
      state.editModalOpen = false;
      toast.error(`${meta.arg} ' : Unable to insert site`);
    },
    [insertSite.fulfilled]: (state, { meta, payload: { data } }) => {
      state.loading = false;
      state.editModalOpen = false;
      state.data.push({
        id: data.siteId,
        name: meta.arg.name,
        url: meta.arg.url,
        botUrl: meta.arg.botUrl,
        botWelcomeMessage: meta.arg.botWelcomeMessage,
        isBotEnabled: meta.arg.isBotEnabled,
        siteChannelType: meta.arg.siteChannelType,
        isSiteOnline: meta.arg.isSiteOnline,
      });
      state.totalCount = state.data.length;
      state.filteredData = state.data;
      toast.success(`New website has been added successfully`);
    },
    [updateSite.pending]: (state) => {
      //state.loading = true;
    },
    [updateSite.rejected]: (state, { meta, error }) => {
      state.loading = false;
      state.editModalOpen = false;
      toast.error(`${meta.arg} ' : Unable to update site`);
    },
    [updateSite.fulfilled]: (state, { meta, payload: { data } }) => {
      state.loading = false;
      state.editModalOpen = false;
      var message = '';
      var site = state.data.find((x) => x.id === meta.arg.id);
      site.name = meta.arg.name;
      site.url = meta.arg.url;
      site.botUrl = meta.arg.botUrl;
      site.botWelcomeMessage = meta.arg.botWelcomeMessage;
      site.isBotEnabled = meta.arg.isBotEnabled;
      site.isSiteOnline = meta.arg.isSiteOnline;
      site.siteChannelType = meta.arg.siteChannelType;
      state.filteredData = state.data;

      if (state.showBotSuccessToast) {
        if (state.isBotEnabled) message = 'Bot enabled successfully';
        else message = 'Bot disabled successfully';
      } else if (state.showSiteSuccessToast) {
        if (state.isSiteOnline) message = 'Site is now online';
        else message = 'Site is now offline';
      } else {
        message = 'Site updated successfully';
      }
      toast.success(`${message}`);
      state.showSiteSuccessToast = false;
      state.showBotSuccessToast = false;
      state.isBotEnabled = false;
      state.isSiteOnline = false;
    },
    [fetchShortcutsByCampaignId.pending]: (state) => {
      state.loading = true;
    },
    [fetchShortcutsByCampaignId.rejected]: (state, { meta, error }) => {
      state.loading = false;
      state.data = state.filteredData = [];
      state.error = error;

      toast.error(`${meta.arg} ' : Unable to get sites...!`);
    },
    [fetchShortcutsByCampaignId.fulfilled]: (
      state,
      { meta, payload: { data } }
    ) => {
      state.loading = false;
      state.error = '';
      state.totalCount = data.shortKeys.length;
      state.data = state.filteredData = data.shortKeys;

      // console.log('state.data = data.transcripts')
      console.log('Sites' + data);
    },
    [deleteShortcut.pending]: (state) => {},
    [deleteShortcut.rejected]: (state, { meta, error }) => {
      state.loading = false;
      toast.error(`${meta.arg} ' : Unable to delete shortcut`);
    },
    [deleteShortcut.fulfilled]: (state, { meta, payload: { data } }) => {
      state.loading = false;
      state.data = state.filteredData = state.data.filter(
        (x) => x.key != meta.arg.key && x.value != meta.arg.message
      );
      state.totalCount = state.data.length;
      toast.success(`Shortcut deleted successfully`);
    },
    [insertShortCut.pending]: (state) => {},
    [insertShortCut.rejected]: (state, { payload }) => {
      state.loading = false;
      state.editModalOpen = false;
      state.error = payload?.Errors
        ? payload.Errors.join(',')
        : 'Network Error';
      toast.error(`Unable to insert shortcut. ${state.error}`);
    },
    [insertShortCut.fulfilled]: (state, { meta, payload: { data } }) => {
      state.loading = false;
      state.editModalOpen = false;
      state.data.push({
        key: meta.arg.key,
        value: meta.arg.message,
      });
      state.totalCount = state.data.length;
      state.filteredData = state.data;
      toast.success(`Shortcut inserted successfully`);
    },
    [updateShortcut.pending]: (state) => {
      state.loading = true;
    },
    [updateShortcut.rejected]: (state, { payload }) => {
      state.loading = false;
      state.editModalOpen = false;
      state.error = payload?.Errors
        ? payload.Errors.join(',')
        : 'Network Error';
      toast.error(`Unable to update shortcut. ${state.error}`);
    },
    [updateShortcut.fulfilled]: (state, { meta, payload: { data } }) => {
      state.loading = false;
      state.editModalOpen = false;
      const shortcut = state.data.find((x) => x.key === meta.arg.key);
      shortcut.key = meta.arg.key;
      shortcut.value = meta.arg.message;
      state.filteredData = state.data;
      toast.success(`Shortcut updated successfully`);
    },
    [getAllCampaigns.pending]: (state) => {
      state.loading = true;
    },
    [getAllCampaigns.rejected]: (state, { error }) => {
      state.loading = false;
      state.error = error;
    },
    [getAllCampaigns.fulfilled]: (state, { meta, payload: { data } }) => {
      state.campaignsData = state.filteredCampaignData = data;
      state.loading = false;
    },

    [createCampaign.pending]: (state) => {
      state.loading = true;
    },
    [createCampaign.rejected]: (state, { payload }) => {
      state.loading = false;
      // state.error = payload?.Errors
      //   ? payload.Errors.join(',')
      //   : 'Network Error';
      state.sucess = false;
      toast.error(
        `${payload?.Errors ? payload.Errors.join(',') : 'Network Error'}`
      );
    },
    [createCampaign.fulfilled]: (state, { meta, payload: { data } }) => {
      state.sucess = true;
      state.loading = false;
      toast.success(`New campaign has been added successfully.`);
    },

    [updateCampaign.pending]: (state) => {
      state.loading = true;
    },
    [updateCampaign.rejected]: (state, { payload }) => {
      state.loading = false;
      // state.error = payload?.Errors
      //   ? payload.Errors.join(',')
      //   : 'Network Error';

      state.sucess = false;
      toast.error(
        `${payload?.Errors ? payload.Errors.join(',') : 'Network Error'}`
      );
    },
    [updateCampaign.fulfilled]: (state, { meta, payload: { data } }) => {
      state.sucess = true;
      state.loading = false;
      toast.success(`Campaign Updated successfully`);
    },

    [deleteCampaign.pending]: (state) => {
      state.loading = true;
    },
    [deleteCampaign.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload?.Errors
        ? payload.Errors.join(',')
        : 'Network Error';
      state.sucess = false;
      toast.error(`Campaign Not Deleted`);
    },
    [deleteCampaign.fulfilled]: (state, { meta, payload: { data } }) => {
      state.sucess = true;
      state.loading = false;
      toast.success(`Campaign Deleted successfully`);
    },

    [getUserCampaignsByEmail.pending]: (state) => {
      // state.loading = true;
    },
    [getUserCampaignsByEmail.rejected]: (state, { payload }) => {
      state.error = payload?.Errors
        ? payload.Errors.join(',')
        : 'Network Error';
      // state.loading = false;
      // toast.error(`Campaigns list not updated.`);
    },
    [getUserCampaignsByEmail.fulfilled]: (
      state,
      { meta, payload: { data } }
    ) => {
      saveItem('userCampaigns', data.campaign);
      // state.loading = false;
      // toast.success(`Campaigns list updated successfully.`);
    },
    [fetchDispositionsByCampaignId.pending]: (state) => {
      state.loading = true;
    },
    [fetchDispositionsByCampaignId.rejected]: (state, { meta, error }) => {
      state.loading = false;
      state.dispositionData = state.filteredDispositionData = [];
      state.error = error;

      toast.error(`${meta.arg} ' : Unable to get dispositions...!`);
    },
    [fetchDispositionsByCampaignId.fulfilled]: (
      state,
      { meta, payload: { data } }
    ) => {
      state.loading = false;
      state.error = '';
      state.totalCount = data.dispositions.length;
      state.dispositionData = state.filteredDispositionData = data.dispositions;

      // console.log('state.data = data.transcripts')
      console.log('dispositions' + data);
    },
    [updateDisposition.pending]: (state) => {
      state.loading = true;
    },
    [updateDisposition.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload?.Errors
        ? payload.Errors.join(',')
        : 'Network Error';
      toast.error(`Unable to update disposition. ${state.error}`);
    },
    [updateDisposition.fulfilled]: (state, { meta, payload: { data } }) => {
      state.loading = false;
      // console.log('payload.data =>  ', data);
      state.totalCount = data.length;
      state.filteredDispositionData = data;
      toast.success(`Disposition updated successfully`);
    },
    [createDisposition.pending]: (state) => {
      state.loading = true;
    },
    [createDisposition.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload?.Errors
        ? payload.Errors.join(',')
        : 'Network Error';
      toast.error(`Unable to create disposition. ${state.error}`);
    },
    [createDisposition.fulfilled]: (state, { meta, payload: { data } }) => {
      state.loading = false;
      // console.log('payload.data =>  ', data);
      state.totalCount = data.length;
      state.filteredDispositionData = data;
      toast.success(`Disposition Created successfully`);
    },
    [deleteDisposition.pending]: (state) => {
      state.loading = true;
    },
    [deleteDisposition.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload?.Errors
        ? payload.Errors.join(',')
        : 'Network Error';
      toast.error(`Unable to delete disposition. ${state.error}`);
    },
    [deleteDisposition.fulfilled]: (state, { meta, payload: { data } }) => {
      state.loading = false;
      // console.log('payload.data =>  ', data);
      state.totalCount = data.length;
      state.filteredDispositionData = data;
      toast.success(`Disposition Deleted successfully`);
    },
  },
});
export const {
  setModalState,
  setDeleteModalState,
  changeBotAvailability,
  changeSiteAvailability,
  filterShortcutsData,
  filterSitesData,
  setErrorAndSucess,
  filterCampaignData,
  filterDispositionData,
  setCampaignFormData,
} = settingsSlice.actions;
export default settingsSlice.reducer;
